import styled from "styled-components";

const PanelHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  color: ${props => props.color ?? props.theme.panel.header.title.defaultColor};
  width: 100%;
`;

const PanelHeaderDetailsContainerWrapper = styled.div`
  display: flex;
  align-items: inherit;
  justify-content: space-between;
  width: 100%;
  padding-right: 1rem;
`;

const PanelHeaderPresentationWrapper = styled.div`
  display: flex;
  align-items: inherit;
`;

const PanelHeaderArrowContainerWrapper = styled.div`
  padding-top: 0.4rem;
`;

const PanelHeaderTextWrapper = styled.span`
  font-weight: 600;
  font-size: 1.3rem;
  text-align: left;
`;

const PanelHeaderDescriptionWrapper = styled(PanelHeaderTextWrapper)`
  color: ${props => props.theme.panel.header.description.defaultColor};
  text-align: right;
`;

export {
  PanelHeaderWrapper,
  PanelHeaderDetailsContainerWrapper,
  PanelHeaderPresentationWrapper,
  PanelHeaderTextWrapper,
  PanelHeaderDescriptionWrapper,
  PanelHeaderArrowContainerWrapper
};
